import React, { Component } from 'react';
import moment from 'moment';
import { Autocomplete, TextField } from 'react-md';
import AccountService from '../../services/AccountService';
import { $override } from '../../../../node_modules/zrender/lib/core/util';

export default class ProfileViewClientAccount extends Component {

    constructor(props) {
        super(props);

        this.state = {
            caInput: '',
            caSelected: '',
            selectedLocs: [],
            caMatch: null,
            pageIndex: 0
        }

        this.accountService = new AccountService();

        this.canSubmit = true;

        this.handleScroll = this.handleScroll.bind(this);

        this.setPageIndex = this.setPageIndex.bind(this);

        this.handleCaInputChange = this.handleCaInputChange.bind(this);
        this.selectClientAccount = this.selectClientAccount.bind(this);
        this.toggleLocationSelected = this.toggleLocationSelected.bind(this);
        this.handleSubmitNewClientAccount = this.handleSubmitNewClientAccount.bind(this);

        this.generateClientAccountList = this.generateClientAccountList.bind(this);
        this.generateClientAccountListAdmin = this.generateClientAccountListAdmin.bind(this);
        this.generateNewForm = this.generateNewForm.bind(this);
    }

    handleScroll(e) {
        this.props.handleScrollTop(e.target.scrollTop <= 0, e.target.scrollTop);
    }

    setPageIndex(dir, limit) {
        let newDir = this.state.pageIndex + dir
        if (newDir < 0) {
            newDir = 0;
        }
        if (newDir >= limit) {
            newDir = this.state.pageIndex;
        }
        this.setState({ pageIndex: newDir });
    }

    handleCaInputChange(textFieldValue, event) {
        let self = this;

        let allClientAccounts = this.props.allClientAccounts;
        let firstMatch = null;
        if (textFieldValue.trim() != '') {
            for (var i = 0; i < allClientAccounts.length; i++) {
                if (allClientAccounts[i].name.toLowerCase().includes(textFieldValue.trim().toLowerCase())) {
                    firstMatch = allClientAccounts[i].name;
                    break;
                }
            }
        }

        this.setState({ caInput: textFieldValue, caSelected: '', selectedLocs: [], caMatch: firstMatch, pageIndex: 0 });
    }

    selectClientAccount(name) {

        this.setState({ caInput: name, caSelected: name, selectedLocs: [] });
    }

    toggleLocationSelected(locationId) {

        let selectedLocs = this.state.selectedLocs;

        let included = false;
        for (var i = 0; i < selectedLocs.length; i++) {
            if (selectedLocs[i] === locationId) {
                included = true;
                selectedLocs.splice(i--, 1);
            }
        }
        if (!included) {
            selectedLocs.push(locationId);
        }

        this.setState({ selectedLocs: selectedLocs });
    }

    handleSubmitNewClientAccount(clientAccountId) {

        let self = this;

        if (this.canSubmit) {
            self.props.loadingOn();
            self.canSubmit = false;

            if (clientAccountId != undefined && clientAccountId != null && clientAccountId != '' &&
                this.state.selectedLocs != undefined && this.state.selectedLocs.length != undefined && this.state.selectedLocs.length > 0 &&
                this.props.profileData.userId != undefined && this.props.profileData.userId != null && this.props.profileData.userId != '') {

                let linkClientAccountRequest = {
                    clientAccountId: clientAccountId,
                    locationIds: this.state.selectedLocs,
                    userId: this.props.profileData.userId
                };

                this.accountService.requestClientAccountLink(linkClientAccountRequest, (res) => {
                    $('.profile-central-outer').scrollTop(0);
                    window.localStorage.setItem('zzCASubmit', true);
                    alert("Account Request Sent");
                    self.props.loadingOff();
                    self.setState({ caInput: '', caSelected: '', selectedLocs: [] }, () => {
                        self.props.handleModeChange('view');
                        self.canSubmit = true;
                    });
                }, (err) => {
                    alert("Something went wrong. Please start over.");
                    self.props.loadingOff();
                    self.setState({ caInput: '', caSelected: '', selectedLocs: [] });
                    self.canSubmit = true;
                });
            } else {
                alert("Something went wrong. Please start over.");
                self.props.loadingOff();
                self.setState({ caInput: '', caSelected: '', selectedLocs: [] });
                self.canSubmit = true;
            }
        }
    }

    generateClientAccountList() {
        let list = [];
        let clientAccounts = this.props.profileData.clientAccountList;
        for (var i = 0; i < clientAccounts.length; i++) {
            if (clientAccounts[i].clientAccountId != "8cc35cfd-352e-4900-825e-8671e330c5da") {
                list.push((
                    <div className="client-account-item">
                        <div className="client-account-icon-container">
                            <div className="material-icons client-account-icon">store_mall_directory</div>
                        </div>
                        <div className="client-account-text-container">
                            <div className="client-account-text-top">{clientAccounts[i].company}</div>
                            <div className="client-account-text-bottom">{clientAccounts[i].locations.length + ' Locations'}</div>
                        </div>
                    </div>
                ));
            }
        }

        if (clientAccounts.length === 0 || (clientAccounts.length === 1 && clientAccounts[0].clientAccountId === "8cc35cfd-352e-4900-825e-8671e330c5da")) {
            list.push((
                <div className="client-account-item" onClick={this.props.handleModeChange.bind(null, 'new')}>
                    <div className="material-icons client-account-add">add</div>
                </div>
            ));
        }

        return list;
    }

    generateClientAccountListAdmin() {
        let list = [];
        let clientAccounts = this.props.profileData.clientAccountList;

        let activeAccount = clientAccounts[zzDataCache.settings.selectedClientAccountIndex];

        if (activeAccount != undefined && activeAccount != null) {
            list.push((
                <div className="profile-central-title-container" style={{ height: '2.5rem' }}>
                    <div className="profile-central-title" style={{ fontSize: '1rem' }}>{"Active Account:"}</div>
                </div>
            ));

            list.push((
                <div className="client-account-item" style={{ borderBottom: 'none' }}>
                    <div className="client-account-icon-container">
                        <div className="material-icons client-account-icon">store_mall_directory</div>
                    </div>
                    <div className="client-account-text-container">
                        <div className="client-account-text-top">{activeAccount.company}</div>
                        <div className="client-account-text-bottom">{activeAccount.locations.length + ' Locations'}</div>
                    </div>
                </div>
            ));
        }

        list.push((
            <div className="new-clientaccount-item" style={{ height: '4.31rem' }}>
                <TextField
                    key="zzcafieldadmin"
                    className="z-md-textfield"
                    fullWidth={true}
                    onChange={this.handleCaInputChange}
                    value={this.state.caInput}
                    defaultValue=""
                    type="text"
                    label="Account Search"
                />
            </div>
        ));

        let optionsList = []
        for (var i = (this.props.profileData.multiClientEnabled ? 0 : 1); i < clientAccounts.length; i++) {
            if (this.state.caInput.trim() === "" || (this.state.caInput.trim() != "" &&
                (clientAccounts[i].company.toLowerCase().includes(this.state.caInput.toLowerCase().trim()) ||
                    clientAccounts[i].companyID.toString().toLowerCase().includes(this.state.caInput.toLowerCase().trim())))) {
                optionsList.push({
                    name: clientAccounts[i].company,
                    jsx: (
                        <div className="client-account-item" onClick={this.props.handleSelectClientAccountAdmin.bind(null, i)}>
                            <div className="client-account-icon-container">
                                <div className="material-icons client-account-icon">store_mall_directory</div>
                            </div>
                            <div className="client-account-text-container">
                                <div className="client-account-text-top" style={clientAccounts[i].company === activeAccount.company ? { color: 'rgba(0, 126, 181, 1)' } : {}}>
                                    {clientAccounts[i].company}
                                </div>
                                <div className="client-account-text-bottom">{clientAccounts[i].locations.length + ' Locations'}</div>
                            </div>
                        </div>
                    )
                });
            }
        }
        let pagingJsx = (
            <div className={"paging-container"}>
                <div className={"material-icons paging-button"} onClick={this.setPageIndex.bind(null, -10).bind(null, optionsList.length)}>{"navigate_before"}</div>
                <div className={"material-icons paging-button"} onClick={this.setPageIndex.bind(null, 10).bind(null, optionsList.length)}>{"navigate_next"}</div>
            </div>
        );
        optionsList = _.sortBy(optionsList, x => x.name.toLowerCase());
        list.push(pagingJsx);
        for (var i = this.state.pageIndex; i < this.state.pageIndex + 10; i++) {
            if (optionsList[i]) {
                list.push(optionsList[i].jsx);
            }
        }
        list.push(pagingJsx);

        return list;
    }

    generateNewForm() {
        let newJsx = [];

        let caButtonText = '';
        let matchedClientAccount = this.props.clientAccountMap[this.state.caMatch];
        if (matchedClientAccount != undefined && matchedClientAccount != null) {
            caButtonText = matchedClientAccount.name;
        }

        let caButtonClass = 'clientaccount-select-button';
        if (this.state.caSelected.trim() != '') {
            caButtonClass += ' active'
        }

        newJsx.push((
            <div className="new-clientaccount-item">
                <TextField
                    key="zzcafield"
                    className="z-md-textfield"
                    fullWidth={true}
                    onChange={this.handleCaInputChange}
                    value={this.state.caInput}
                    defaultValue=""
                    type="text"
                    label="Account Name"
                />
                <div className={caButtonClass} onClick={caButtonText === '' ? null : this.selectClientAccount.bind(null, caButtonText)}>{caButtonText}</div>
            </div>
        ));

        let selectedCa = null;
        for (var i = 0; i < this.props.allClientAccounts.length; i++) {
            if (this.props.allClientAccounts[i].name.toLowerCase() === this.state.caSelected.trim().toLowerCase()) {
                selectedCa = this.props.allClientAccounts[i];
                break;
            }
        }

        if (selectedCa != null) {

            for (var i = 0; i < selectedCa.locations.length; i++) {

                let tmpClass = 'new-clientaccount-location';
                if (this.state.selectedLocs.includes(selectedCa.locations[i].locationId)) {
                    tmpClass += ' new-clientaccount-location--active';
                }

                newJsx.push((
                    <div className="new-clientaccount-item">
                        <div className={tmpClass} onClick={this.toggleLocationSelected.bind(null, selectedCa.locations[i].locationId)}>
                            {selectedCa.locations[i].name}
                        </div>
                    </div>
                ));
            }

            if (this.state.selectedLocs.length > 0) {
                newJsx.push((
                    <div className="new-clientaccount-item">
                        <div className="new-clientaccount-submit" onClick={this.handleSubmitNewClientAccount.bind(null, selectedCa.clientAccountId)}>
                            SUBMIT
                        </div>
                    </div>
                ))
            }
        }

        return newJsx;
    }

    render() {

        let clientAccountListJsx = (this.props.profileData.userType === 0 || this.props.profileData.multiClientEnabled) ?
            this.generateClientAccountListAdmin() : this.generateClientAccountList();

        let newJsx = this.generateNewForm();

        let viewStyle = {
            transform: 'scale(1, 1)',
            opacity: '1',
            pointerEvents: 'auto'
        };
        let newStyle = {
            transform: 'scale(0.5, 0.5)',
            opacity: '0',
            pointerEvents: 'none',
            position: 'absolute',
            top: '0',
            left: '0'
        };
        if (this.props.mode === 'new') {
            viewStyle = {
                transform: 'scale(1.5, 1.5)',
                opacity: '0',
                pointerEvents: 'none'
            };
            newStyle = {
                transform: 'scale(1, 1)',
                opacity: '1',
                pointerEvents: 'auto',
                position: 'absolute',
                top: '0',
                left: '0'
            };
        }

        let caSubmitted = window.localStorage.getItem('zzCASubmit');

        let canAddProfile = false;
        if (this.props.profileData.clientAccountList != undefined && this.props.profileData.clientAccountList != null &&
            this.props.profileData.clientAccountList.length === 1 &&
            this.props.profileData.clientAccountList[0].clientAccountId === "8cc35cfd-352e-4900-825e-8671e330c5da") {
            canAddProfile = true;
        }

        return (
            <div className="profile-central-outer" onScroll={this.handleScroll} style={this.props.style}>
                <div className="profile-central-regular-card-container" style={viewStyle}>
                    <div className="profile-central-title-container">
                        <div className="profile-central-title">{
                            "Accounts" +
                            (this.props.profileData.clientAccountList.length === 0 && caSubmitted != undefined && caSubmitted != null && caSubmitted.toString() === 'true' ?
                                ' - Pending' : '')
                        }</div>
                        <div className="profile-central-subtitle">{"Your list of accessible accounts"}</div>
                    </div>
                    <div className="profile-client-account-list">
                        {clientAccountListJsx}
                    </div>
                </div>
                {!canAddProfile ? null :
                    (<div className="profile-central-regular-card-container" style={newStyle}>
                        <div className="profile-central-title-container">
                            <div className="profile-central-title">{"Add Account"}</div>
                            <div className="profile-central-subtitle">{""}</div>
                        </div>
                        {newJsx}
                        <div className="spacer-1"></div>
                    </div>)
                }
                <div className="spacer-1"></div>
            </div>
        );
    }
}